import { useTheme } from '@emotion/react';
import { useMediaQuery } from '@mui/material';
import type { FC } from 'react';
import React from 'react';
import OtpInput from 'react-otp-input';

const EnterOtpInput: FC<any> = (props) => {
  const { otpDigit } = props;
  const theme: any = useTheme();
  const underSm = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      <OtpInput
        inputType="number"
        numInputs={otpDigit}
        // custom === 'verifyPin' ? 6 : 6
        inputStyle={{
          border: '1px #D0D5DD solid',
          borderRadius: '8px',
          fontWeight: 500,
          margin: `${underSm ? '0.3rem' : '0.5rem'}`,
          color: '#000',
          width: `${underSm ? '1.2rem' : '3.5rem'}`,
          height: `${underSm ? '1.2rem' : '3.5rem'}`,
          fontSize: `${underSm ? '22px' : '38px'}`,
          opacity: 1,
          transition: 'border .3s ease-in-out',
          outline: 'none',
          textAlign: 'center', // Center the text within input

          // Responsive styles
          '@media (max-width: 768px)': {
            width: '3rem', // Adjust width for smaller screens
            height: '3rem', // Adjust height for smaller screens
            fontSize: '24px', // Adjust font size for smaller screens
          },
        }}
        renderInput={(params) => (
          <div className="otpInput">
            <input {...params} type="number" placeholder="0" />
          </div>
        )}
        shouldAutoFocus
        {...props}
        separator=" - "
      />
    </div>
  );
};

export default EnterOtpInput;
